import './_spinner.scss';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Spinner = ({ className }) => (
  <FontAwesomeIcon
    icon={faSpinner}
    className={classNames('loaders__button-spinner', {
      [className]: !!className,
    })}
  />
)

Spinner.propTypes = {
  className: PropTypes.string,
}

export default Spinner;
